<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="reportType" :label="$t('举报类型')">
<!--        <span slot="label" >
          <a-tooltip>
            举报类型：用户/文章/评论<template slot="title">举报类型：用户/文章/评论</template>
          </a-tooltip>
        </span>-->
      </a-form-model-item>
      <a-form-model-item prop="contentId" :label="$t('被举报内容ID')">
<!--        <span slot="label" >
          <a-tooltip>
            被举报内容ID<template slot="title">被举报内容ID</template>
          </a-tooltip>
        </span>-->
        <a-input v-model="form.contentId"  :placeholder="$t('请输入')+$t('被举报内容ID')" />
      </a-form-model-item>
      <a-form-model-item prop="contentType" :label="$t('内容类型')">
<!--        <span slot="label" >
          <a-tooltip>
            内容类型<template slot="title">内容类型</template>
          </a-tooltip>
        </span>-->
      </a-form-model-item>
      <a-form-model-item prop="reportedContent" :label="$t('被举报内容')">
<!--        <span slot="label" >
          <a-tooltip>
            被举报内容<template slot="title">被举报内容</template>
          </a-tooltip>
        </span>-->
        <editor v-model="form.reportedContent" />
      </a-form-model-item>
      <a-form-model-item prop="reporterId" :label="$t('举报人ID')">
<!--        <span slot="label" >
          <a-tooltip>
            举报人ID<template slot="title">举报人ID</template>
          </a-tooltip>
        </span>-->
        <a-input v-model="form.reporterId"  :placeholder="$t('请输入')+'举报人ID'" />
      </a-form-model-item>
      <a-form-model-item prop="reporterName" :label="$t('举报人姓名')">
<!--        <span slot="label" >
          <a-tooltip>
            举报人姓名<template slot="title">举报人姓名</template>
          </a-tooltip>
        </span>-->
        <a-input v-model="form.reporterName" :maxLength="100" :placeholder="$t('请输入')+$t('举报人姓名')" />
      </a-form-model-item>
      <a-form-model-item prop="reportImage" :label="$t('举报图片URL')">
<!--        <span slot="label" >
          <a-tooltip>
            举报图片URL，多个用逗号分隔<template slot="title">举报图片URL，多个用逗号分隔</template>
          </a-tooltip>
        </span>-->
        <file-upload v-model="form.reportImage" type="image"></file-upload>
      </a-form-model-item>
      <a-form-model-item prop="description" :label="$t('举报描述')">
<!--        <span slot="label" >
          <a-tooltip>
            举报描述<template slot="title">举报描述</template>
          </a-tooltip>
        </span>-->
        <a-input v-model="form.description" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="status" :label="$t('举报状态')">
<!--        <span slot="label" >
          <a-tooltip>
            举报状态：0-待处理，1-已处理，2-无需处理<template slot="title">举报状态：0-待处理，1-已处理，2-无需处理</template>
          </a-tooltip>
        </span>-->
      </a-form-model-item>
      <a-form-model-item prop="reportTime" :label="$t('举报时间')">
<!--        <span slot="label" >
          <a-tooltip>
            举报时间<template slot="title">举报时间</template>
          </a-tooltip>
        </span>-->
        <a-date-picker style="width: 100%" v-model="form.reportTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="handleResult" :label="$t('处理结果')">
<!--        <span slot="label" >
          <a-tooltip>
            处理结果：0-无需处理，1-处理完成<template slot="title">处理结果：0-无需处理，1-处理完成</template>
          </a-tooltip>
        </span>-->
        <a-input v-model="form.handleResult"  :placeholder="$t('请输入')+$t('处理结果')" />
      </a-form-model-item>
      <a-form-model-item prop="handlerId" :label="$t('处理人ID')">
<!--        <span slot="label" >
          <a-tooltip>
            处理人ID<template slot="title">处理人ID</template>
          </a-tooltip>
        </span>-->
        <a-input v-model="form.handlerId"  :placeholder="$t('请输入')+$t('处理人ID')" />
      </a-form-model-item>
      <a-form-model-item prop="handlerName" :label="$t('处理人姓名')">
<!--        <span slot="label" >
          <a-tooltip>
            处理人姓名<template slot="title">处理人姓名</template>
          </a-tooltip>
        </span>-->
        <a-input v-model="form.handlerName" :maxLength="100" :placeholder="$t('请输入')+$t('处理人姓名')" />
      </a-form-model-item>
      <a-form-model-item prop="handleTime" :label="$t('处理时间')">
<!--        <span slot="label" >
          <a-tooltip>
            处理时间<template slot="title">处理时间</template>
          </a-tooltip>
        </span>-->
        <a-date-picker style="width: 100%" v-model="form.handleTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="handleRemark" :label="$t('处理备注')">
<!--        <span slot="label" >
          <a-tooltip>
            处理备注<template slot="title">处理备注</template>
          </a-tooltip>
        </span>-->
        <a-input v-model="form.handleRemark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="remark" v-if="formType === 1" :label="$t('备注')">
<!--        <span slot="label" >
          <a-tooltip>
            备注<template slot="title">备注</template>
          </a-tooltip>
        </span>-->
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDiscoveryReport, addDiscoveryReport, updateDiscoveryReport } from '@/api/discovery/discoveryReport'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";

import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
    Editor
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        reportType: null,

        contentId: null,

        contentType: null,

        reportedContent: null,

        reporterId: null,

        reporterName: null,

        reportImage: null,

        description: null,

        status: 0,

        reportTime: null,

        handleResult: null,

        handlerId: null,

        handlerName: null,

        handleTime: null,

        handleRemark: null,

        createTime: null,
        localeFieldMap:{},

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        reportType: [
          { required: true, message: '举报类型：用户/文章/评论'+this.$t('不能为空'), trigger: 'change' }
        ],
        contentId: [
          { required: true, message: '被举报内容ID'+this.$t('不能为空'), trigger: 'blur' }
        ],
        contentType: [
          { required: true, message: '内容类型'+this.$t('不能为空'), trigger: 'change' }
        ],
        reportedContent: [
          { required: true, message: '被举报内容'+this.$t('不能为空'), trigger: 'blur' }
        ],
        reporterId: [
          { required: true, message: '举报人ID'+this.$t('不能为空'), trigger: 'blur' }
        ],
        reporterName: [
          { required: true, message: '举报人姓名'+this.$t('不能为空'), trigger: 'blur' }
        ],
        reportImage: [
          { required: true, message: '举报图片URL，多个用逗号分隔'+this.$t('不能为空'), trigger: 'blur' }
        ],
        description: [
          { required: true, message: '举报描述'+this.$t('不能为空'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: '举报状态：0-待处理，1-已处理，2-无需处理'+this.$t('不能为空'), trigger: 'blur' }
        ],
        reportTime: [
          { required: true, message: '举报时间'+this.$t('不能为空'), trigger: 'blur' }
        ],
        handleResult: [
          { required: true, message: '处理结果：0-无需处理，1-处理完成'+this.$t('不能为空'), trigger: 'blur' }
        ],
        handlerId: [
          { required: true, message: '处理人ID'+this.$t('不能为空'), trigger: 'blur' }
        ],
        handlerName: [
          { required: true, message: '处理人姓名'+this.$t('不能为空'), trigger: 'blur' }
        ],
        handleRemark: [
          { required: true, message: '处理备注'+this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        reportType: null,
        contentId: null,
        contentType: null,
        reportedContent: null,
        reporterId: null,
        reporterName: null,
        reportImage: null,
        description: null,
        status: 0,
        reportTime: null,
        handleResult: null,
        handlerId: null,
        handlerName: null,
        handleTime: null,
        handleRemark: null,
        createTime: null,
        localeFieldMap:{},
        remark: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDiscoveryReport({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateDiscoveryReport(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addDiscoveryReport(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
